<template>
    <div class="top-menu-upgrade" v-if="!hasPremium">
        <div class="hover"></div>
        <slot>
            <a :href="url">
                <Crown class="crown-img" :baseData="baseData" size="24" />
                {{name}}
            </a>
        </slot>
    </div>
</template>

<script>
import Crown from '@root/lk/create/CreateChallenge/Crown.vue';

export default {
    props: ["name", "url", "crown", "baseData",],
    components: {
        Crown,
    },
    mounted() {
    },
    computed: {
        hasPremium() {
            const user = this.baseData?.viewingUser;
            if (!user) return false;
            if (!user.permissions) return false;
            if (!user.permissions.activePlans) return false;
            return user.permissions.activePlans.length > 0;
        },
    },
    methods: {      
    }
}
</script>

<style lang="scss" scoped>
    .top-menu-upgrade {
        padding: 0;
        font-size: 18px;
        font-weight: 600;
        align-content: center;
        position: relative;
        &:hover {
            cursor: pointer;
            background: none;
            //box-shadow: 0 3px 0 #6179E0;
            //z-index: 99999999;
            .hover {
                display: block;
            } 
        }
        .hover {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 32px;
            height: 3px;
            background: #FFC107;
            display: none;
        }
        a {
            text-decoration: none;
            color: #FFC107;
        }
    }
    
</style>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>
